export const PartnerPageSetttings = `<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<circle cx="16" cy="19" r="3" stroke="currentColor" stroke-width="2"/>
<path d="M21 29V27C21 25.8954 20.1046 25 19 25H13C11.8954 25 11 25.8954 11 27V29" stroke="currentColor" stroke-width="2" stroke-linejoin="round"/>
<rect x="3" y="13" width="26" height="16" rx="1" stroke="currentColor" stroke-width="2"/>
<rect x="3" y="3" width="6" height="6" rx="1" stroke="currentColor" stroke-width="2"/>
<rect x="13" y="3" width="6" height="6" rx="1" stroke="currentColor" stroke-width="2"/>
<rect x="23" y="3" width="6" height="6" rx="1" stroke="currentColor" stroke-width="2"/>
</svg>`;
